//Flickity Slider
import Flickity from 'flickity';
import 'flickity-imagesloaded/flickity-imagesloaded';

export function initThreeColumnPlan() {
    if (window.acf) {
        window.acf.addAction(
            'render_block_preview/type=three-column-plan',
            threeColumnPlan
        );
    }
}

export function threeColumnPlan() {
    var carousel = document.querySelector('.three-column-plan');
    if (carousel) {
        var flickityCarousel = false;

        if (carousel.querySelectorAll('.item').length > 3 || window.innerWidth < 768) {
            carousel.classList.remove("flex", "flex-wrap", "md:-mx-4");
            flickityCarousel = new Flickity(carousel, {
                prevNextButtons: false,
                groupCells: true,
                cellAlign: 'left',
                imagesLoaded: true,
            });
        } else {
            carousel.classList.add("flex", "flex-wrap", "md:-mx-4");
        }

        window.addEventListener('resize', function () {
            if (window.innerWidth < 768) {
                carousel.classList.remove("flex", "flex-wrap", "md:-mx-4");
                if (flickityCarousel) flickityCarousel.destroy();
                flickityCarousel = new Flickity(carousel, {
                    prevNextButtons: false,
                    groupCells: true,
                    cellAlign: 'left',
                    imagesLoaded: true,
                });
            } else {
                if (flickityCarousel) flickityCarousel.destroy();
                carousel.classList.add("flex", "flex-wrap", "md:-mx-4");
                flickityCarousel = false;
            }
        });
    }
}